import { useCallback, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import styles from "./RenderSelectedProduct2.module.css";
import { Button, SkeletonBodyText, Text, TextField, Thumbnail } from "@shopify/polaris";
import { ProductObj, VariantsObj } from "../../apps/Bundles/Types";
import { BundleTypes } from "../../apps/Bundles/constants";
import DragHandle from "../Icons/DragHandle";
import CloseIcon from "../Icons/CloseIcon";

const RenderSelectedProduct2 = ({
    bundleType,
    products,
    submit,
    hideQuantity = false,
    multiple = 10,
    products_type = "",
    handleFieldChange = () => {},
    resourcePickerQuery = "status:active AND published_status:published",
    showLabel = false,
}: {
    bundleType: string;
    products: any;
    customTitle?: string;
    submit: any;
    isMobile: boolean;
    hideQuantity?: boolean;
    multiple?: number | boolean;
    products_type?: string;
    handleFieldChange?: any;
    resourcePickerQuery?: string;
    showLabel?: boolean;
}) => {
    const [renderArr, setRenderArr] = useState<any[]>([]);

    useEffect(() => {
        if (products?.length) {
            submit();
        }
        setRenderArr(products);

        return () => {
            if (products?.length) {
                submit();
            }
        };
    }, [products]);

    const moveCard = useCallback(
        (originalIdx: number, newIdx: number) => {
            const temp = [...renderArr];
            const draggedCard = {
                ...temp[originalIdx],
            };
            temp.splice(originalIdx, 1);
            temp.splice(newIdx, 0, draggedCard);

            setRenderArr(temp);
            handleFieldChange(temp);
        },
        [renderArr, products],
    );

    const removeProduct = (pId: string = "", vId: string = "") => {
        typeof vId;
        const temp: ProductObj[] = [...renderArr];
        let idx: number | undefined = -1;

        idx = temp.findIndex((p) => p.id == pId);
        if (idx >= 0) {
            temp.splice(idx, 1);
            handleFieldChange(temp);
        }
    };
    const handleQuantity = (pId = "", vId = "", val: number) => {
        typeof vId;
        const temp: ProductObj[] = [...renderArr];
        let idx: number | undefined = -1;

        const quantity = val <= 0 ? 1 : val;
        typeof quantity;

        idx = temp.findIndex((p) => p.id == pId);

        if (idx >= 0) {
            temp[idx] = {
                ...temp[idx],
                quantity: val,
            };
        }

        handleFieldChange(temp);
    };

    const [isFetchingRequest, setIsFetchingRequest] = useState(false);

    const handleProductSearch = async (initialQuery: string = "") => {
        const preSelected = products?.map((product: ProductObj) => ({
            id: product?.id,
            variants: product?.variants.map((variant: VariantsObj) => ({
                id: variant?.id,
            })),
        }));
        const selected: any = await shopify.resourcePicker({
            type: "product",
            multiple: multiple,
            query: initialQuery,
            action: "select",
            selectionIds: preSelected,
            filter: {
                query: resourcePickerQuery,
                variants: true,
            },
        });
        if (selected) {
            const productsArr: ProductObj[] = [];
            selected?.flatMap((product: any) => {
                productsArr.push({
                    id: product?.id,
                    images: product?.images,
                    title: product?.title,
                    handle: product?.handle,
                    quantity: 1,
                    maxProductStock: product?.totalInventory,
                    selectedVariants: [],
                    subscriptions: [],
                    oneTimePurchase: true,
                    isSubscribed: false,
                    variants: product?.variants?.map((variant: VariantsObj) => ({
                        image: { ...variant.image },
                        id: variant?.id,
                        displayName: variant.displayName,
                        title: variant?.title?.toLowerCase() == "default title" ? product?.title : variant?.title,
                        price: variant?.price,
                        quantity: 1,
                        selectedOptions: variant?.selectedOptions,
                        copyPrice: variant.price,
                        compareAtPrice: variant.compareAtPrice ? variant.compareAtPrice : variant.price,
                    })),
                    options: product?.options,
                });
            });

            try {
                setIsFetchingRequest(true);
                handleFieldChange(productsArr);
                setIsFetchingRequest(false);
            } catch (error) {
                console._log(error);
                setIsFetchingRequest(false);
                handleFieldChange(productsArr);
            }
        }
    };

    const onDropReferences = (res: any) => {
        if (!res?.destination?.droppableId || !res?.source?.droppableId) return;
        else {
            moveCard(res.source.index, res.destination.index);
        }
    };

    const getLabel = () => {
        if (bundleType === "product_add_on") {
            return products_type === "main_product"
                ? `Add Specific Product${multiple === 1 ? "" : "s"}`
                : `Add Add-on Product${multiple === 1 ? "" : "s"}`;
        }

        return renderArr?.length === multiple
            ? `Edit Product${multiple === 1 ? "" : "s"}`
            : `+ Add Product${multiple === 1 ? "" : "s"}`;
    };

    // console._log("isMobile", isMobile);

    return (
        // @ts-expect-error hack
        <DragDropContext onDragEnd={onDropReferences}>
            {
                // @ts-expect-error hack
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div className={styles.headingsDiv} {...provided.droppableProps} ref={provided.innerRef}>
                            {showLabel ? (
                                <div className={styles.productNameWrapper} style={{ justifyContent: "space-between" }}>
                                    <Text as="p" fontWeight="bold">
                                        Select Products
                                    </Text>
                                    {!!products?.length && (
                                        <Button onClick={() => handleProductSearch()} variant={"secondary"}>
                                            {getLabel()}
                                        </Button>
                                    )}
                                </div>
                            ) : (
                                !!products?.length && (
                                    <div className={styles.productNameWrapper}>
                                        <Button onClick={() => handleProductSearch()} variant={"secondary"}>
                                            {getLabel()}
                                        </Button>
                                    </div>
                                )
                            )}
                            {renderArr?.length ? (
                                <div className={styles.productsRender}>
                                    {renderArr.map((product: any, pIdx: number) => (
                                        // @ts-expect-error required
                                        <Draggable
                                            key={product?.variants[0]?.id}
                                            draggableId={product?.variants[0]?.id + ""}
                                            index={pIdx}
                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    key={product?.variants[0]?.id}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        ...provided.draggableProps.style,
                                                        borderRadius: 10,
                                                        border: snapshot.isDragging
                                                            ? "1px solid black"
                                                            : "1px solid transparent",
                                                        backgroundColor: "white",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    <div {...provided.dragHandleProps}>
                                                        <DragHandle />
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            cursor: "default",
                                                        }}
                                                    >
                                                        <div className={styles.productMeta}>
                                                            <div className={styles.productName}>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        overflow: "hidden",
                                                                        border: `1px solid var(--p-color-border)`,
                                                                        cursor: "pointer",
                                                                        maxWidth: 25,
                                                                        maxHeight: 25,
                                                                        minWidth: 25,
                                                                        minHeight: 25,
                                                                        background: "var(--p-color-bg-surface)",
                                                                        borderRadius: "var(--p-border-radius-200)",
                                                                    }}
                                                                >
                                                                    <Thumbnail
                                                                        source={product?.images[0]?.originalSrc}
                                                                        alt={product?.images[0]?.altText}
                                                                        size={"small"}
                                                                    />
                                                                </div>
                                                                <div className={styles.productTitleWrapper}>
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: "normal",
                                                                            cursor: "pointer",
                                                                            display: "-webkit-box",
                                                                            WebkitLineClamp: 2,
                                                                            WebkitBoxOrient: "vertical",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            width: "100%",
                                                                            minWidth: 100,
                                                                        }}
                                                                        onClick={() => {
                                                                            if (shopify.config.shop) {
                                                                                window.open(
                                                                                    `https://${shopify.config.shop}/products/${product.handle}`,
                                                                                    "_blank",
                                                                                );
                                                                            }
                                                                        }}
                                                                        className={styles.productTitle}
                                                                        title={product?.title}
                                                                    >
                                                                        {product?.title}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: 11,
                                                                        }}
                                                                    >
                                                                        {product?.variants?.length > 1 ? (
                                                                            <div>
                                                                                <span
                                                                                    className={styles.variantsLabel}
                                                                                    onClick={() => {
                                                                                        handleProductSearch(
                                                                                            product?.title,
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {`${product?.variants?.length}
                                                                            variants
                                                                            `}
                                                                                </span>
                                                                                included
                                                                            </div>
                                                                        ) : (
                                                                            ``
                                                                        )}
                                                                    </div>

                                                                    {bundleType != BundleTypes.VOLUME_DISCOUNT &&
                                                                        !product?.subscriptions?.length &&
                                                                        isFetchingRequest && (
                                                                            <SkeletonBodyText lines={1} />
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={styles.productQty}
                                                                style={{
                                                                    marginTop: -25,
                                                                }}
                                                            >
                                                                {[BundleTypes.BXGY, BundleTypes.STANDARD].includes(
                                                                    bundleType as any,
                                                                ) &&
                                                                    !hideQuantity && (
                                                                        <div
                                                                            style={{
                                                                                minWidth: 90,
                                                                                maxWidth: 90,
                                                                            }}
                                                                        >
                                                                            <TextField
                                                                                label={
                                                                                    <div
                                                                                        style={{
                                                                                            fontSize: 12,
                                                                                            fontWeight: 450,
                                                                                            marginBottom: -3,
                                                                                        }}
                                                                                    >
                                                                                        Quantity
                                                                                    </div>
                                                                                }
                                                                                type={"number"}
                                                                                min={1}
                                                                                autoComplete={"off"}
                                                                                onChange={(val) => {
                                                                                    const regex = /^\d*$/;
                                                                                    if (!regex.test(val)) {
                                                                                        return;
                                                                                    }

                                                                                    const quantity = +val;

                                                                                    handleQuantity(
                                                                                        product?.id,
                                                                                        product.variants[0]?.id,
                                                                                        quantity,
                                                                                    );
                                                                                }}
                                                                                size={"slim"}
                                                                                value={
                                                                                    (+product.quantity).toString() as unknown as string
                                                                                }
                                                                                onBlur={() => {
                                                                                    if (+product.quantity <= 0) {
                                                                                        handleQuantity(
                                                                                            product?.id,
                                                                                            product.variants[0]?.id,
                                                                                            1,
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                <div
                                                                    onClick={() => {
                                                                        removeProduct(
                                                                            product?.id,
                                                                            product?.variants[0]?.id,
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        marginTop: "22px",
                                                                    }}
                                                                >
                                                                    <CloseIcon />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.variantsWrapper}></div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            ) : (
                                <div className={styles.emptyProductBox} onClick={() => handleProductSearch()}>
                                    <Button variant={"secondary"} loading={isFetchingRequest}>
                                        {getLabel()}
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </Droppable>
            }
        </DragDropContext>
    );
};

export default RenderSelectedProduct2;
